export let dataProps = {
    id: 0,
    designation_name: '',
    job_description: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/designationMaster/properties.js